module.exports = __webpack_public_path__ + "static/media/two_pote_pricing.92395333.png";